/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryuntitled2Inputs */

const en_medialibraryuntitled2 = /** @type {(inputs: Medialibraryuntitled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

const de_medialibraryuntitled2 = /** @type {(inputs: Medialibraryuntitled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Titel`)
};

/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Medialibraryuntitled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryuntitled2 = /** @type {((inputs?: Medialibraryuntitled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryuntitled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryuntitled2(inputs)
	return de_medialibraryuntitled2(inputs)
});
export { medialibraryuntitled2 as "mediaLibraryUntitled" }